module.exports = __webpack_public_path__ + "img/401.0f4bc32b.gif";